/**
 * TypingDots — 3 анимированные точки, индикатор «AI печатает».
 *
 * Render внутри MessageStream когда sending=true. Имеет ту же геометрию,
 * что и assistant-bubble, чтобы скролл/высота не прыгали.
 */
export default function TypingDots() {
    return (
        <div
            className="conversation__typing"
            role="status"
            aria-label="AI печатает ответ"
        >
            <span />
            <span />
            <span />
        </div>
    )
}
